import { FC, PropsWithChildren } from "react";
import { GlobalModalProvider } from "rujira.ui";
import { useAccounts } from "./accounts";
import { useRedacted } from "./redacted";

/** The account the app acts for: the view, Spending account and wallet. */
export const useAccountScope = (): string => {
  const { isPrivateMode, subWalletAddress } = useRedacted();
  const { selected } = useAccounts();
  return [
    isPrivateMode ? `private:${subWalletAddress ?? ""}` : "public",
    selected?.provider ?? "",
    selected?.address.address ?? "",
  ].join("|");
};

/**
 * The app's dialogs, each bound to the account it was opened for: Private
 * Mode on or off, another Spending account, another wallet or address closes
 * it, instead of letting its form go on for the new account (for example pay
 * a connected wallet from the Spending account).
 */
export const AccountScopedModalProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const accountScope = useAccountScope();
  return (
    <GlobalModalProvider accountScope={accountScope}>
      {children}
    </GlobalModalProvider>
  );
};
